export const loadAPIImage = (src) => {
    if (!src) return;
    return process.env.VUE_APP_API_URL + "/api/files/" + src;
}